import { Avatar } from "./Avatar";
import { Text } from "@twilio-paste/core";
import { Menu, MenuButton, useMenuState, MenuItem } from "@twilio-paste/menu";
import { Button } from "@twilio-paste/button"; //nik
import { ChevronDownIcon } from "@twilio-paste/icons/esm/ChevronDownIcon";
import React, { useMemo, useState } from "react";
import styles from "../styles";
import { Client, ConnectionState, User } from "@twilio/conversations";
import { LogoTwilioIcon } from "@twilio-paste/icons/esm/LogoTwilioIcon";
import UserProfileModal from "./modals/UserProfileModal";
import BulkSmsModal from "./modals/BulkSmsModal"; //nik
import SetAutoReplyModal from "./modals/SetAutoReplyModal"; //nik
import { readUserProfile } from "../api";
import { conversationsMap } from "../conversations-objects";
import { useSelector } from "react-redux"; //nik
import { AppState } from "../store"; //nik
import S from "./icons/S";

type AppHeaderProps = {
  user: string;
  onSignOut: () => void;
  connectionState: ConnectionState;
  client?: Client;
};
const AppHeader: React.FC<AppHeaderProps> = ({
  user,
  onSignOut,
  connectionState,
  client,
}) => {
  const menu = useMenuState();

  const [showUserProfileModal, setUserProfileModal] = useState(false);

  const [userProfile, setUserProfile] = useState<User | undefined>(undefined);

  const handleUserProfileModalClose = () => setUserProfileModal(false);

  //o

  const [showBulkSmsModal, setBulkSmsModal] = useState(false);

  const handleBulkSmsModalClose = () => setBulkSmsModal(false);

  const loadingStatus = useSelector((state: AppState) => state.loadingStatus);

  ///c

  //o

  const [showSetAutoReplyModal, setSetAutoReplyModal] = useState(false);

  const handleSetAutoReplyModalClose = () => setSetAutoReplyModal(false);

  ///c

  const label: "online" | "connecting" | "offline" = useMemo(() => {
    switch (connectionState) {
      case "connected":
        return "online";
      case "connecting":
        return "connecting";
      default:
        return "offline";
    }
  }, [connectionState]);

  const handleUserProfileModalOpen = async () => {
    const userProfileTemp = await readUserProfile(user, client);
    setUserProfile(userProfileTemp);
    setUserProfileModal(true);
  };

  /// o nik
  const handleBulkSmsModalOpen = async () => {
    setBulkSmsModal(true);
  };
  ///c
  /// o nik
  const handleSetAutoReplyOpen = async () => {
    setSetAutoReplyModal(true);
  };
  ///c

  return (
    <div style={styles.appHeader}>
      <div style={styles.flex}>
        <div style={styles.appLogoWrapper}>
          {/*<LogoTwilioIcon
            decorative={false}
            color={"colorTextBrandHighlight"}
            size={"sizeIcon40"}
            title="app logo"
          /> */}
          <S />
        </div>
        <div style={styles.appLogoTitle}>
          Twilio Conversations
          <div style={styles.appLogoSubTitle}>for Spellsology</div>
        </div>
      </div>
      <div style={styles.userTile}>
        <Button
          variant="secondary"
          onClick={handleBulkSmsModalOpen}
          loading={loadingStatus}
        >
          Send SMS to Subscribed Contacts ({conversationsMap.size})
        </Button>
      </div>
      <div style={styles.userTile}>
        <Avatar name={user} />
        <div
          style={{
            padding: "0 10px",
          }}
        >
          <Text as="span" style={styles.userName}>
            {user}
          </Text>
          <Text
            as="span"
            color={
              label === "online"
                ? "colorTextPrimaryWeak"
                : label === "connecting"
                ? "colorTextIconBusy"
                : "colorTextWeaker"
            }
            style={styles.userStatus}
          >
            {label === "online"
              ? "Online"
              : label === "connecting"
              ? "Connecting…"
              : "Offline"}
          </Text>
        </div>
        <MenuButton {...menu} variant="link" size="reset">
          <ChevronDownIcon
            color="colorTextInverse"
            decorative={false}
            title="Settings"
          />
        </MenuButton>
        <Menu {...menu} aria-label="Preferences">
          <MenuItem {...menu} onClick={onSignOut}>
            Sign Out
          </MenuItem>
          <MenuItem {...menu} onClick={handleUserProfileModalOpen}>
            User Profile
          </MenuItem>
          <MenuItem {...menu} onClick={handleSetAutoReplyOpen}>
            Auto Reply Settings
          </MenuItem>
        </Menu>
      </div>
      {showUserProfileModal && (
        <UserProfileModal
          isModalOpen={showUserProfileModal}
          handleClose={handleUserProfileModalClose}
          user={userProfile}
        ></UserProfileModal>
      )}
      {showBulkSmsModal && (
        <BulkSmsModal
          isModalOpen={showBulkSmsModal}
          handleClose={handleBulkSmsModalClose}
          title="Send Bulk SMS"
        ></BulkSmsModal>
      )}
      {/* {showSetAutoReplyModal && (
        <SetAutoReplyModal
          isModalOpen={showSetAutoReplyModal}
          handleClose={handleSetAutoReplyModalClose}
          user={userProfile}
        ></SetAutoReplyModal>
      )} */}
    </div>
  );
};

export default AppHeader;
